/* eslint-disable @typescript-eslint/no-extraneous-class */
export interface CusstomStyle {
  warpStyle?: React.CSSProperties;
  textStyle?: React.CSSProperties;
  imageStyle?: React.CSSProperties;
}

// 富文本model
export interface AttContentData {
  attContents?: []; // rich text 数组
  icon?: string; // icon 图标
  style?: CusstomStyle; // warp 特殊样式 例如星标外边框特殊处理
}

// 富文本处理方法
export class RichContentUtils {
  // handle content
  static getTextContent(props: any): AttContentData {
    const { itemKey } = props;
    switch (itemKey) {
      case 'distance':
        // 距离
        return this.distanceRichContents(props);
      case 'minCostPrice':
        // 起送价
        return this.minCostPriceRichContents(props);
      case 'shopAvgSpend':
        // 门店人均销量金额（新
        return this.shopAvgSpendRichContents(props);
      case 'shopCategory':
        // 门店分类
        return this.shopCategoryRichContents(props);
      case 'shopSaleInfo':
        // 30天销量
        return this.shopSaleInfoRichContents(props);
      case 'shopScore':
        // 商户评分
        return this.shopScoreRichContents(props);
      case 'deliveryTime':
        // 配送时间
        return this.deliveryTimeRichContents(props);
      case 'foodPrepareTime':
        // 取餐时间-自取
        return this.pickupTimeRichContents(props);
      case 'deliveryFee':
        // 配送费
        return this.deliveryFeeichContents(props);
      case 'productDeliveryFee':
        // 配送费
        return this.deliveryFeeichContents(props);
      case 'shopName':
        // 店铺名字
        return this.shopNameRichContents(props);
      case 'subCardTitle':
        // 副标题
        return this.shopNameRichContents(props);
      case 'brandName':
        // 品牌名
        return this.brandNameRichContents(props);
      case 'spuName':
        // 店铺名称标签
        return this.spuNameRichContents(props);
      case 'spuPrice':
        // 店铺名称标签
        return this.spuPriceRichContents(props);
      case 'spuDesc':
        // 商品描述
        return this.spuDescRichContents(props);
      case 'spuFinalPrice':
        // 菜品到手价
        return this.spuFinalPriceRichContents(props);
      case 'shippingFreeIcon':
        // 免运标签
        return this.shippingFreeIconRichContents(props);
      case 'outOfRangeInfo':
        // 超配描述
        return this.outOfRangeContents(props);
      case 'alienSpuFinalPrice':
        // 单行异形价格（突出整数部分）
        return this.alienSpuFinalPriceRichContents(props);
      case 'spuDrawlinePrice':
        // 划线价
        return this.spuDrawLinePriceRichContents(props);
      case 'shopLogo':
        // 品牌logo
        return this.shopLogoRichContents(props);
      case 'spuDBLRowName':
        // 商品描述（双行）
        return this.spuDBLRowNameRichContents(props);
      default:
        return {};
    }
  }

  // default render object
  private static setContentNameWithIcon(textName: string, icon: string = '', textAtt: any[] = [], style: any = {}) {
    const contents: any = [...textAtt];
    if (textName) {
      const baselineOffset = Mach.env.isIOS ? 0.5 : undefined;
      contents.push({
        type: 'text',
        text: `${textName}`,
        color: '#4D4D4D',
        fontSize: 12,
        fontFamily: 'KeeTa-Regular',
        lineHeight: 18,
        baselineOffset
      });
    }
    return { attContents: contents, icon, style };
  }

  private static distanceRichContents(props: any) {
    const textName = props?.data?.distance?.desc;
    const icon = props?.data?.distanceIconUrl;
    return this.setContentNameWithIcon(textName, icon);
  }

  private static minCostPriceRichContents(props: any) {
    const textName = props?.data?.minCostPrice?.displayText;
    return this.setContentNameWithIcon(textName);
  }

  private static shopAvgSpendRichContents(props: any) {
    const textName = props?.data?.shopAvgSpend;
    return this.setContentNameWithIcon(textName);
  }

  private static shopCategoryRichContents(props: any) {
    const textName = props?.data?.shopCategoryName;
    return this.setContentNameWithIcon(textName);
  }

  private static shopSaleInfoRichContents(props: any) {
    const textName = props?.data?.shopSaleInfo?.displayText;
    return this.setContentNameWithIcon(textName);
  }

  private static shopScoreRichContents(props: any) {
    const { icon, score } = props?.data?.shopScoreInfo || {};
    let textAtts; let
      style;
    if (score) {
      const baselineOffset = Mach.env.isIOS ? 0.5 : undefined;
      textAtts = [{
        type: 'text',
        text: `${score}`,
        color: '#222222',
        fontSize: 12,
        fontFamily: 'KeeTa-Bold',
        lineHeight: 18,
        fontWight: 700,
        baselineOffset,
      }];
    }
    if (props.style?.customProperty?.hasBorder && (icon !== undefined || score !== undefined)) {
      const warpStyle: React.CSSProperties = {
        background: '#FFFBE6', paddingLeft: 4, paddingRight: 4, height: 20, borderRadius: 4
      };
      const textStyle = Mach.env.isAndroid ? { marginBottom: 2 } : {};
      style = { warpStyle, textStyle };
    }
    return this.setContentNameWithIcon('', icon, textAtts, style);
  }

  private static deliveryTimeRichContents(props: any) {
    const textName = props?.data?.deliveryTimeDesc;
    const icon = props?.data?.deliveryTimeIconUrl;
    return this.setContentNameWithIcon(textName, icon);
  }

  private static pickupTimeRichContents(props: any) {
    const textName = props?.data?.diningReadyTimeDesc;
    const icon = props?.data?.diningReadyTimeIconUrl;
    return this.setContentNameWithIcon(textName, icon);
  }

  private static deliveryFeeichContents(props: any) {
    const contents: any = [];

    const data = props?.data;
    const deliveryFee = data?.deliveryFee;
    const disableShowDrawLineDeliveryFee = data?.disableShowDrawLineDeliveryFee;
    const finalDeliveryFeeInfo = data?.finalDeliveryFeeInfo;
    const deliveryOriginPrice = deliveryFee?.displayText;
    const deliveryPrice = finalDeliveryFeeInfo?.price?.displayText;
    const isFinalDeliveryFree = deliveryPrice && (finalDeliveryFeeInfo?.price?.amount === 0);
    const priceCondition = finalDeliveryFeeInfo?.priceCondition;
    const showDeliveryPrice = deliveryPrice && deliveryOriginPrice && (deliveryFee.amount > finalDeliveryFeeInfo.price.amount);

    const fontSize = 12;
    const fontFamily = 'KeeTa-Regular';
    const blackColor = '#222222';
    const grayColor = '#808080';
    const greenColor = '#00B987';

    const origionDeliveryFeeTextColor = data?.origionDeliveryFeeTextColor || blackColor;
    const drawLineDeliveryFeeTextColor = data?.drawLineDeliveryFeeTextColor || grayColor;
    const finalDeliveryFeeTextColor = data?.finalDeliveryFeeTextColor;

    // 分隔符样式
    // ❗️❗️❗️❗️❗️使用placeHolder会导致整个富文本向下偏移，先用空格顶上
    const placeholder = {
      type: 'text',
      text: ' ',
      fontSize,
      fontFamily,
    };

    // 配送费
    const deliverySubTags: any[] = [];
    const baselineOffset = Mach.env.isIOS ? 0.5 : undefined;
    const isBold = isFinalDeliveryFree || finalDeliveryFeeTextColor;

    // 配送费到手价
    if (showDeliveryPrice) {
      deliverySubTags.push({
        type: 'text',
        text: `${deliveryPrice}`,
        color: finalDeliveryFeeTextColor || (isFinalDeliveryFree ? greenColor : blackColor),
        fontSize,
        fontFamily: isBold ? 'KeeTa-Bold' : 'KeeTa-Regular',
        fontWeight: isBold ? 700 : 400, // 安卓必须携带fontWeight否则默认细体
        baselineOffset,
      });
    }

    // 配送费原价
    if (deliveryOriginPrice && (deliverySubTags.length === 0 || !disableShowDrawLineDeliveryFee)) {
      if (showDeliveryPrice) {
        deliverySubTags.push(placeholder);
      }
      deliverySubTags.push({
        type: 'text',
        text: deliveryOriginPrice,
        color: showDeliveryPrice ? drawLineDeliveryFeeTextColor : origionDeliveryFeeTextColor,
        fontSize,
        fontFamily,
        textDecoration: showDeliveryPrice ? 'line-through' : 'null',
        baselineOffset,
      });
    }

    if (priceCondition) {
      if (showDeliveryPrice || deliveryOriginPrice) {
        deliverySubTags.push(placeholder);
      }
      deliverySubTags.push({
        type: 'text',
        text: `${priceCondition}`,
        color: grayColor,
        fontSize,
        fontFamily,
        baselineOffset,
      });
    }
    contents.push(...deliverySubTags);
    const deliveryIconUrl = data?.deliveryIconUrlV2 || data?.deliveryIconUrl;
    return this.setContentNameWithIcon('', deliveryIconUrl, contents);
  }

  private static shopNameRichContents(props: any) {
    const data = props.data;
    const nameIconList = this.getShopNameIconList(data);
    const content: any[] = [];
    // 间隔
    const placeholder = {
      type: 'placeholder',
      width: 4
    };
    const lineHeight = 21; // 行高：粗体行高较高
    if (nameIconList) {
      for (let i = 0; i < nameIconList.length; i++) {
        if (nameIconList[i] && nameIconList[i].picUrl && nameIconList[i].width > 0 && nameIconList[i].height > 0) {
          content.push({
            type: 'image',
            src: nameIconList[i].picUrl,
            width: nameIconList[i].width || 0,
            height: nameIconList[i].height || 0,
            verticalOffset: Math.floor(nameIconList[i].height - lineHeight) * 0.5,
            verticalAlignment: 'center'
          });
          content.push(placeholder);
        }
      }
    }

    const customStyles = props.style?.customProperty || {};
    // 店铺名称
    if (data.name) {
      content.push({
        type: 'text',
        text: data.name,
        backgroundColor: 'clear',
        color: '#222222',
        fontFamily: 'KeeTa-Bold',
        fontSize: 16,
        fontWeight: 700,
        ...customStyles
      });
    }

    if (data.subCardTitle) {
      content.push({
        type: 'text',
        text: data.subCardTitle,
        backgroundColor: 'clear',
        color: '#222222',
        fontFamily: 'KeeTa-Bold',
        fontSize: 16,
        fontWeight: 700,
        ...customStyles
      });
    }
    const textStyle = Mach.env.isAndroid ? { lineHeight } : {};
    const style = { textStyle };
    return this.setContentNameWithIcon('', '', content, style);
  }

  // 获取店铺名称前缀标签
  private static getShopNameIconList = (data) => {
    if (!data) {
      return null;
    }
    const iconList: { picUrl: string; width: number; height: number; }[] = [];
    if (data.closeLabel) {
      iconList.push(data.closeLabel);
    }
    // 优先自取
    if (data.pickUpIcon) {
      iconList.push(data.pickUpIcon);
    }
    // 其次店铺类型
    if (data.featureLabel) {
      iconList.push(data.featureLabel);
    }
    return iconList;
  }

  private static brandNameRichContents = (props: any) => {
    const brandName = props?.data?.brandName;

    const content: any[] = [];

    // 店铺名称
    if (brandName) {
      content.push({
        type: 'text',
        text: brandName,
        backgroundColor: 'clear',
        color: '#222222',
        fontFamily: 'KeeTa-Bold',
        fontSize: 16,
        fontWeight: 700,
      });
    }
    const style = {};

    return this.setContentNameWithIcon('', '', content, style);
  }

  private static spuNameRichContents = (props: any) => {
    const name = props?.data?.name;
    const customStyles = props.style?.customProperty || {};

    const content: any[] = [];
    // 店铺名称
    if (name) {
      content.push({
        type: 'text',
        text: name,
        backgroundColor: 'clear',
        color: '#222222',
        fontFamily: 'KeeTa-Regular',
        fontSize: 12,
        fontWeight: 400,
        ...customStyles
      });
    }
    const style = {};
    return this.setContentNameWithIcon('', '', content, style);
  }

  private static spuPriceRichContents = (props: any) => {
    const finalPrice = props?.data?.finalPrice?.displayText;
    const originPrice = props?.data?.originPrice?.displayText;
    const customStyles = props.style?.customProperty || {};
    const finalPriceTextColor = props?.data?.finalPriceTextColor || '#222222';
    const {
      originPriceStyles, finalPriceStyles, finalPriceMaxWidth = 55, ...lineStyles
    } = customStyles;
    const content: any[] = [];
    const SLCommon = Mach.requireModule('SLCommon');

    // 最终价根据是否分割大小字区别计算
    const finalPriceWidth = SLCommon.widthForText({
      content: finalPrice,
      fontSize: 14,
    });
    const originPriceWidth = SLCommon.widthForText({
      content: originPrice,
      fontSize: 12,
    });
    // 最终价格根据两个价格总宽是否超出限制
    const isLongFinalPrice = Number(finalPriceWidth) + Number(originPriceWidth) > 2 * finalPriceMaxWidth;
    // 店铺名称
    if (finalPrice) {
      content.push({
        type: 'text',
        text: finalPrice,
        backgroundColor: 'clear',
        color: finalPriceTextColor,
        fontFamily: 'KeeTa-Bold',
        fontSize: 14,
        fontWeight: 700,
        ...finalPriceStyles
      });
    }
    if (originPrice && !isLongFinalPrice) {
      content.push({
        type: 'placeholder',
        width: 4
      });
      content.push({
        type: 'text',
        text: originPrice,
        backgroundColor: 'clear',
        color: '#808080',
        fontFamily: 'KeeTa-Regular',
        fontSize: 12,
        fontWeight: 400,
        textDecoration: 'line-through',
        ...originPriceStyles
      });
    }
    const style = {
      textStyle: lineStyles
    };

    return this.setContentNameWithIcon('', '', content, style);
  }

  private static spuDescRichContents(props) {
    const textName = props?.data?.description;
    const contents: any = [];
    if (textName) {
      const baselineOffset = Mach.env.isIOS ? 0.5 : undefined;
      contents.push({
        type: 'text',
        text: `${textName}`,
        color: '#737373',
        fontSize: 12,
        fontFamily: 'KeeTa-Regular',
        baselineOffset,
      });
    }
    return this.setContentNameWithIcon('', '', contents);
  }

  private static outOfRangeContents(props) {
    const textName = props?.data?.text;
    const contents: any = [];
    if (textName) {
      contents.push({
        type: 'text',
        text: `${textName}`,
        color: '#CC3300',
        fontSize: 12,
        fontFamily: 'KeeTa-Regular',
      });
    }
    return this.setContentNameWithIcon('', '', contents);
  }

  private static spuFinalPriceRichContents(props) {
    const textName = props?.data?.finalPrice?.displayText;
    const customStyles = props.style?.customProperty || {};

    const contents: any = [];
    if (textName) {
      const baselineOffset = Mach.env.isIOS ? 0.5 : undefined;
      contents.push({
        type: 'text',
        text: `${textName}`,
        color: '#222222',
        fontSize: 14,
        fontFamily: 'KeeTa-Bold',
        fontWeight: 700,
        baselineOffset,
        ...customStyles
      });
    }
    return this.setContentNameWithIcon('', '', contents);
  }

  private static shippingFreeIconRichContents(props) {
    const icon = props?.data?.shippingFreeIcon;
    const style = {
      imageStyle: { width: icon?.width, height: icon?.height }
    };
    return this.setContentNameWithIcon('', icon?.picUrl, [], style);
  }

  private static alienSpuFinalPriceRichContents(props) {
    const textColor = props?.data?.textColor;
    const currency = props?.data?.finalPrice?.currency;
    const displayAmount = props?.data?.finalPrice?.displayAmount;
    const SLMPI18N = Mach.requireModule('Intl');
    const { locale = 'en' } = SLMPI18N.getCurrentLocaleInfo() || {};
    const contents: any = [];
    if (locale === 'ar') {
      if (displayAmount) {
        contents.push({
          type: 'text',
          text: `${displayAmount}`,
          fontFamily: 'KeeTa-Bold',
          fontSize: 14,
          color: textColor,
          fontWeight: 700,
        });
      }
      if (currency) {
        contents.push({
          type: 'placeholder',
          width: 2
        });
        contents.push({
          type: 'text',
          text: `${currency}`,
          fontFamily: 'KeeTa-Bold',
          fontSize: 10,
          color: textColor,
          fontWeight: 700,
        });
      }
    } else {
      if (currency) {
        contents.push({
          type: 'text',
          text: `${currency}`,
          fontFamily: 'KeeTa-Bold',
          fontSize: 10,
          color: textColor,
          fontWeight: 700,
        });
      }
      if (displayAmount) {
        contents.push({
          type: 'placeholder',
          width: 2
        });
        contents.push({
          type: 'text',
          text: `${displayAmount}`,
          fontFamily: 'KeeTa-Bold',
          fontSize: 14,
          color: textColor,
          fontWeight: 700,
        });
      }
    }
    return this.setContentNameWithIcon('', '', contents);
  }

  private static spuDrawLinePriceRichContents(props) {
    const textColor = props?.data?.textColor;
    const displayText = props?.data?.drawLinePrice?.displayText;
    const contents: any = [];
    if (displayText) {
      contents.push({
        type: 'text',
        text: `${displayText}`,
        fontFamily: 'KeeTa-Regular',
        fontSize: 10,
        color: textColor,
        fontWeight: 400,
        textDecoration: 'line-through'
      });
    }
    return this.setContentNameWithIcon('', '', contents);
  }

  private static shopLogoRichContents(props) {
    const icon = props?.data?.logo;
    const customStyles = props.style?.customProperty || {};
    const style = {
      imageStyle: { ...customStyles, width: icon?.width, height: icon?.height }
    };
    return this.setContentNameWithIcon('', icon?.picUrl, [], style);
  }

  private static spuDBLRowNameRichContents(props) {
    const name = props?.data?.name;
    const customStyles = props.style?.customProperty || {};
    const content: any[] = [];
    if (name) {
      content.push({
        type: 'text',
        text: name,
        backgroundColor: 'clear',
        color: '#222222',
        fontFamily: 'KeeTa-Regular',
        fontSize: 12,
        fontWeight: 400,
        ...customStyles
      });
    }
    const style = {};
    return this.setContentNameWithIcon('', '', content, style);
  }
}
